import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('setSafeMailingListsOption')(function setSafeMailingListsOption(safeMailingLists, state) {
    var optionState = state.optionState;
    optionState.safeMailingLists = safeMailingLists;
}));
//# sourceMappingURL=setSafeMailingListsOption.js.map